// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kalign-version {
    margin-bottom: 0;
    text-align: end;
    font-size: 12px;
    opacity: 0.8;
}
button.msa-params-button.ui-btn {
    justify-content: end;
}`, "",{"version":3,"sources":["webpack://./css/msa.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB","sourcesContent":[".kalign-version {\n    margin-bottom: 0;\n    text-align: end;\n    font-size: 12px;\n    opacity: 0.8;\n}\nbutton.msa-params-button.ui-btn {\n    justify-content: end;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
